export default defineNuxtPlugin(async (NuxtApp) => {
  const { AppCookieNames } = await import('~/assets/constants/ecomApi');

  const authStore = useAuthStore();
  const auth_token = useCookie<{ value: string } | null>(AppCookieNames.CustomerJWT);
  if (!auth_token.value || !auth_token.value.value) {
    authStore.user = null;
    return;
  }

  try {
    const runtimeConfig = useRuntimeConfig();
    const response = await authStore.setAuthUserByToken(
      auth_token.value.value,
      NuxtApp,
      runtimeConfig
    );

    if (response && response.id) {
      const { useRootStore } = await import('~/stores/root.store');
      const rootStore = useRootStore();
      authStore.user = rootStore.clone(response);
      if (authStore.user?.default_branch) {
        const { setUserDefaultBranchOnRefresh } = await import('~/stores-datalayer/auth.datalayer');
        setUserDefaultBranchOnRefresh(authStore.user.default_branch);
      }
    }
  } catch (error) {
    const nuxtApp = tryUseNuxtApp();
    const errorMeta = { authError: true };
    if (nuxtApp) {
      nuxtApp?.$customClientErrorHandler?.(
        error,
        'critical',
        'Auth Plugin Error - trying to set auth user by token using setAuthUserByToken()',
        errorMeta
      );
    }
    authStore.user = null;
  }
});
